
angular.module('v3sWbtPlayerApp').directive('v3sSettings', ["v3sWbtSettingsService", "v3sBrowserInfoService", "v3sWbtInfo", "v3sUserService", function (v3sWbtSettingsService, v3sBrowserInfoService, v3sWbtInfo,v3sUserService) {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: "app/js/navigation/settings/settings.tpl.html",
        controller: ["$scope", "$element", function ($scope, $element) {
            $scope.info = v3sWbtInfo;
            $scope.settings = v3sWbtSettingsService.get();
            $scope.user = v3sUserService;
            $scope.hideAudioMuteButton = v3sBrowserInfoService.isIosBrowser() || v3sBrowserInfoService.isIosWebApp() || v3sBrowserInfoService.isIosAppViversa();
            $scope.$watchCollection("settings", function (newSettings, oldSettings) {
                //Wenn audio auf stumm gestellt wird, sollen die Untertitel angezeigt werden
                if (newSettings.muteAudio && newSettings.muteAudio !== oldSettings.muteAudio) {
                    newSettings.showSubtitle = true;
                }
                v3sWbtSettingsService.update(newSettings);
            });
        }]
    }
}]);
